<template lang="pug">
  
  .SelectionBox(@click.stop="$emit('click')")
    .selection-box-content
      .search(
        v-if="searchEnabled"
        :class="{'shadow': searchShadowVisible}")
        IconSearch
        input.search-input(
          @input="onSearchKeywordInput($event.target.value)"
          :value="searchKeyword"
          :placeholder="searchPlaceholder ? searchPlaceholder : $t('generic.placeholder.search')")
      .options(
        ref="options"
        :class="{'no-search': !searchEnabled}"
        @scroll="onOptionsScroll")
        .option(
          v-for="(option, index) in visibleOptions"
          :key="index")
          ToggleBox(
            v-if="useToggle"
            :label="option[labelKey]"
            :value="option[selectKey]"
            :disabled="option[disabledKey]"
            :circle="true"
            @input="onSelectionChange(option, ...arguments)")
          Checkbox(
            v-else
            :label="option[labelKey]"
            :checked="option[selectKey]"
            :disabled="option[disabledKey]"
            @onChange="onSelectionChange(option, ...arguments)")

</template>

<script>

import Checkbox from '@/component/checkbox'
import ToggleBox from '@/component/toggle-box'

export default {
  name: "SelectionBox",

  components: {
    Checkbox,
    ToggleBox
  },

  props: {
    options: {
      type: Array,
      required: true
    },
    searchKeyword: {
      type: String
    },
    labelKey: {
      type: String,
      default: "name"
    },
    selectKey: {
      type: String,
      default: "selected"
    },
    disabledKey: {
      type: String,
      default: "disabled"
    },
    searchPlaceholder: {
      type: String
    },
    searchEnabled: {
      type: Boolean,
      default: true
    },
    useToggle: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      optionsScrollTop: 0
    }
  },

  computed: {
    searchShadowVisible() {
      return (this.optionsScrollTop !== 0)
    },

    visibleOptions() {
      return this.searchKeyword
        ? this.options.filter(o => o[this.labelKey].toLowerCase().includes(this.searchKeyword.toLowerCase()))
        : this.options
    }
  },

  methods: {
    onSearchKeywordInput(value) {
      this.$emit("search", value)
    },

    onOptionsScroll() {
      this.optionsScrollTop = this.$refs.options.scrollTop
    },

    onSelectionChange(option, value) {
      this.$emit("selectionChange", option, value)
    }
  }

}
</script>

<style lang="scss" scoped>

  .SelectionBox {
    width: 100%;
    border: 1px solid $color-hide;
    border-radius: $border-radius;
    background-color: white;
    max-height: 155px;

    .selection-box-content {
      width: 100%;
      height: 100%;

      .search {
        height: 42px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        color: $color-gray;
        transition: all .2s;

        .search-input {
          margin-left: 15px;

          &::placeholder {
            color: $color-gray;
          }
        }

        &.shadow {
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
        }
      }

      .options {
        padding: 0 15px;
        max-height: 113px;
        overflow-y: auto;

        &.no-search {
          padding-top: 10px;
        }

        .option {
          padding: 7px 0;

          &:last-of-type {
            padding-bottom: 14px;
          }
        }

        &::-webkit-scrollbar {
          width: 5px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: $border-radius;
          background: #e4e4e4;
        }
      }
    }
  }

</style>


